<template>
  <div class="p-3">
    <div v-if="question.questionTypeId == types.TextoAbierto">
      <label class="label" for="areafield">
        {{ question.additionalQuestionDescription }}
      </label>
      <validation-provider
        v-slot="{ errors }"
        :name="
          `section-complete-${question.sectionId}-question-${question.additionalQuestionId}`
        "
        rules="required"
      >
        <custom-text-area
          :id="`comment-${question.additionalQuestionId}`"
          v-model="value"
          :count-classes="['d-block text-right']"
          :custom-error-msg="
            customErrorMsg(question.additionalQuestionDescription)
          "
          :disabled="readOnly"
          :error="errors[0]"
          :maxlength="3000"
          name="areafield"
          show-char-count
          @input="emitTouched"
        />
      </validation-provider>
    </div>
    <div v-else-if="question.questionTypeId == types.VoF">
      <label class="label" for="eqType">
        {{ question.additionalQuestionDescription }}
      </label>
      <validation-provider
        v-slot="{ errors }"
        :name="
          `section-complete-${question.sectionId}-question-radio-${question.additionalQuestionId}`
        "
        rules="required"
      >
        <custom-radio
          v-model="value"
          :change-event="onSelectedAnswers"
          custom-error-msg="Favor seleccione"
          :disabled="readOnly"
          :error="Boolean(errors[0])"
          is-inline
          name="penaltyOptions"
          :options="defaultOptions"
        />
      </validation-provider>
    </div>
  </div>
</template>

<script>
import CustomRadio from 'custom-radio';
import CustomTextArea from 'CustomTextArea';
import questionTypes from './questionTypes';

export default {
  name: 'ProposalEvaluationComplete',
  components: {
    CustomRadio,
    CustomTextArea,
  },
  props: {
    question: {
      type: Object,
      default: () => {},
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    types: questionTypes,
    value: null,
    questionTypeId: null,
  }),
  computed: {
    defaultOptions() {
      return [
        {
          id: 1,
          name: 'complete-rbnt-true',
          value: true,
          label: 'Si',
          check: false,
          invalid: false,
        },
        {
          id: 2,
          name: 'complete-rbnt-false',
          value: false,
          label: 'No',
          check: false,
          invalid: false,
        },
      ];
    },
    customErrorMsg() {
      return (question) => {
        const questionLabel = question.toLowerCase().trim();
        let message = 'Favor llenar información.';

        if (questionLabel.includes('sobresaliente')) {
          message = 'Favor mencione si identificó algún aspecto sobresaliente.';
        } else if (questionLabel.includes('debilidad')) {
          message =
            'Favor precise si algún aspecto o punto de debilidad si alguno, que llamara su atención o que le limitara en el ejercicio de establecer puntuaciones.';
        }

        return message;
      };
    },
  },
  watch: {
    value(current) {
      if (this.questionTypeId == 2) {
        this.$emit('filled', String(current.value));
      } else {
        this.$emit('filled', current);
      }
    },
    question: {
      deep: true,
      immediate: true,
      handler(current) {
        this.questionTypeId = current.questionTypeId;
        if (current.answer === 'true' || current.answer === 'false') {
          this.value = this.defaultOptions.filter(
            (f) => String(f.value) == current.answer
          )[0];
        } else {
          this.value = current.answer;
        }
      },
    },
  },
  methods: {
    onSelectedAnswers(item) {
      this.value = item;
      this.emitTouched();
    },
    emitTouched() {
      this.$emit('isTouched', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 1.125rem;
}
.sub-title {
  margin: 5px 0px 0px 5px;
}
.label {
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .label,
  .sub-title {
    font-size: 0.8571rem;
  }
  .title {
    font-size: 1rem;
  }
}
</style>
